import React, { useState } from 'react';
import './AboutUsDashboard.css';

const AboutUsDashboard = () => {
  const [aboutContent, setAboutContent] = useState({
    mainDescription: 'VTAS Associates is an independent firm of Chartered Accountants in Sri Lanka...',
    vision: 'To be the most trusted and preferred Chartered Accounting firm in Sri Lanka...',
    mission: 'To provide comprehensive, high-quality, and timely financial and advisory services...'
  });

  const [partners, setPartners] = useState([
    { id: 1, name: 'Mr. Asela Mudannayake', position: 'Partner', description: 'Mr. Asela Mudannayake holds a BSc in Accounting...', image: '' },
    { id: 2, name: 'Mr. Pradeep Sanjeewa', position: 'Partner', description: 'Mr. Pradeep Sanjeewa is a Chartered professional...', image: '' }
  ]);

  const [editingPartner, setEditingPartner] = useState(null);
  const [partnerFormData, setPartnerFormData] = useState({ name: '', position: '', description: '', image: '' });
  const [activeTab, setActiveTab] = useState('content');

  // Handle About Content Update
  const handleAboutContentChange = (field, value) => {
    setAboutContent(prev => ({ ...prev, [field]: value }));
  };

  const handleSaveAboutContent = () => {
    alert('About Us content saved successfully!');
  };

  // Handle Partner Operations
  const handleAddPartner = () => {
    if (!partnerFormData.name || !partnerFormData.position) {
      alert('Please fill in name and position');
      return;
    }

    const newPartner = {
      id: Date.now(),
      ...partnerFormData
    };
    setPartners(prev => [...prev, newPartner]);
    setPartnerFormData({ name: '', position: '', description: '', image: '' });
  };

  const handleEditPartner = (partner) => {
    setEditingPartner(partner.id);
    setPartnerFormData({ 
      name: partner.name, 
      position: partner.position, 
      description: partner.description, 
      image: partner.image 
    });
  };

  const handleUpdatePartner = () => {
    setPartners(prev => prev.map(partner => 
      partner.id === editingPartner 
        ? { ...partner, ...partnerFormData }
        : partner
    ));
    setEditingPartner(null);
    setPartnerFormData({ name: '', position: '', description: '', image: '' });
  };

  const handleDeletePartner = (id) => {
    if (window.confirm('Delete this partner?')) {
      setPartners(prev => prev.filter(partner => partner.id !== id));
    }
  };

  const handleCancelEdit = () => {
    setEditingPartner(null);
    setPartnerFormData({ name: '', position: '', description: '', image: '' });
  };

  return (
    <div className="about-dashboard-container">
      <div className="about-dashboard-header">
        <h1 className="about-dashboard-title">About Us Management</h1>
        <p className="about-dashboard-subtitle">Manage company information and partners</p>
      </div>

      <div className="about-tab-container">
        <button 
          className={`about-tab-btn ${activeTab === 'content' ? 'active' : ''}`}
          onClick={() => setActiveTab('content')}
        >
          About Content
        </button>
        <button 
          className={`about-tab-btn ${activeTab === 'partners' ? 'active' : ''}`}
          onClick={() => setActiveTab('partners')}
        >
          Partners
        </button>
      </div>

      {activeTab === 'content' && (
        <div className="about-dashboard-content">
          <div className="about-form-section">
            <h2 className="about-section-title">Edit About Us Content</h2>
            
            <div className="about-form-group">
              <label className="about-form-label">Main Description</label>
              <textarea
                value={aboutContent.mainDescription}
                onChange={(e) => handleAboutContentChange('mainDescription', e.target.value)}
                className="about-form-textarea"
                placeholder="Enter main company description"
                rows="4"
              />
            </div>

            <div className="about-form-group">
              <label className="about-form-label">Vision Statement</label>
              <textarea
                value={aboutContent.vision}
                onChange={(e) => handleAboutContentChange('vision', e.target.value)}
                className="about-form-textarea"
                placeholder="Enter company vision"
                rows="4"
              />
            </div>

            <div className="about-form-group">
              <label className="about-form-label">Mission Statement</label>
              <textarea
                value={aboutContent.mission}
                onChange={(e) => handleAboutContentChange('mission', e.target.value)}
                className="about-form-textarea"
                placeholder="Enter company mission"
                rows="4"
              />
            </div>

            <div className="about-button-group">
              <button onClick={handleSaveAboutContent} className="about-btn-primary">
                Save About Content
              </button>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'partners' && (
        <div className="about-dashboard-content">
          <div className="about-form-section">
            <h2 className="about-section-title">
              {editingPartner ? 'Edit Partner' : 'Add New Partner'}
            </h2>
            
            <div className="about-form-group">
              <label className="about-form-label">Partner Name</label>
              <input
                type="text"
                value={partnerFormData.name}
                onChange={(e) => setPartnerFormData({...partnerFormData, name: e.target.value})}
                className="about-form-input"
                placeholder="Enter partner name"
              />
            </div>

            <div className="about-form-group">
              <label className="about-form-label">Position / Title</label>
              <input
                type="text"
                value={partnerFormData.position}
                onChange={(e) => setPartnerFormData({...partnerFormData, position: e.target.value})}
                className="about-form-input"
                placeholder="Enter position (e.g., Partner, Senior Partner)"
              />
            </div>

            <div className="about-form-group">
              <label className="about-form-label">Description / Bio</label>
              <textarea
                value={partnerFormData.description}
                onChange={(e) => setPartnerFormData({...partnerFormData, description: e.target.value})}
                className="about-form-textarea"
                placeholder="Enter partner description or biography"
                rows="5"
              />
            </div>

            <div className="about-form-group">
              <label className="about-form-label">Image URL</label>
              <input
                type="text"
                value={partnerFormData.image}
                onChange={(e) => setPartnerFormData({...partnerFormData, image: e.target.value})}
                className="about-form-input"
                placeholder="Enter image URL or path"
              />
            </div>

            {partnerFormData.image && (
              <div className="about-image-preview">
                <label className="about-form-label">Image Preview</label>
                <div className="about-preview-box">
                  <img src={partnerFormData.image} alt="Preview" onError={(e) => e.target.style.display = 'none'} />
                </div>
              </div>
            )}

            <div className="about-button-group">
              {editingPartner ? (
                <>
                  <button onClick={handleUpdatePartner} className="about-btn-primary">
                    Update Partner
                  </button>
                  <button onClick={handleCancelEdit} className="about-btn-secondary">
                    Cancel
                  </button>
                </>
              ) : (
                <button onClick={handleAddPartner} className="about-btn-primary">
                  Add Partner
                </button>
              )}
            </div>
          </div>

          <div className="about-list-section">
            <h2 className="about-section-title">
              Current Partners ({partners.length})
            </h2>
            
            <div className="about-partners-list">
              {partners.length === 0 ? (
                <p className="about-empty-text">No partners yet. Add your first one above.</p>
              ) : (
                partners.map(partner => (
                  <div key={partner.id} className="about-partner-card">
                    <div className="about-partner-preview">
                      {partner.image ? (
                        <img src={partner.image} alt={partner.name} />
                      ) : (
                        <div className="about-no-image">No Image</div>
                      )}
                    </div>
                    <div className="about-partner-info">
                      <h3 className="about-partner-name">{partner.name}</h3>
                      <h4 className="about-partner-position">{partner.position}</h4>
                      <p className="about-partner-desc">
                        {partner.description.substring(0, 100)}
                        {partner.description.length > 100 ? '...' : ''}
                      </p>
                    </div>
                    <div className="about-partner-actions">
                      <button 
                        onClick={() => handleEditPartner(partner)}
                        className="about-btn-edit"
                      >
                        Edit
                      </button>
                      <button 
                        onClick={() => handleDeletePartner(partner.id)}
                        className="about-btn-delete"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutUsDashboard;